export default {
  // 0: "We provide professional solutions for different industries and application areas to enhance the productivity of enterprises.",
  // 1: "Authing allow users to access all systems with one account and log in securely to government services.",
  // 2: "Keep readers focused and hundreds of millions of users in control.",
  // 3: "Enable Financial Cloud, an intuitive and visual analytics platform that complies with national regulatory standards.",
  // 4: "Let players come in fast and keep hackers away. Fast logins from multiple identity sources, and ensure user access to sensitive information.",
  // 5: "One authentication multipoint interconnection, one software global monitoring.",
  // 6: "A safe and seamless student experience that protects students and staff.",
  // 行业解决方案: "Industry Solutions",
  // 免费使用: "Free Access",
  // 查看文档: "View Document",
  // 查看详情: "Learn More",
  // 政府: "Government",
  // 出版: "Publisher",
  // 金融: "Finance",
  // 游戏: "Game",
  // 软件业: "Software",
  // 教育: "Education",
  list: {
    banner: {
      title: "Industry Solutions",
      subtitle:
        "We provide professional solutions for different industries and application areas to enhance the productivity of enterprises.",
    },
    "hot-solution": {
      title: "Popular Solutions",
      subtitle:
        "Aiming at the characteristics of the Internet, finance, government and enterprises, manufacturing, education and other fields, we will create personalized industry solutions.",
      "common-detial": "Learn more",
      education: {
        title: "Education",
        subtitle:
          "A safe and seamless student experience that protects students and staff.",
      },
      game: {
        title: "Game",
        subtitle:
          "Players come in fast and keep hackers away. Fast logins from multiple identity sources, and ensure user access to sensitive information.",
      },
      it: {
        title: "Software",
        subtitle:
          "One authentication multipoint interconnection, one software global monitoring.",
      },
      govenment: {
        title: "Government",
        subtitle:
          "Authing allow users to access all systems with one account and log in securely to government services.",
      },
      finance: {
        title: "Finance",
        subtitle:
          "Enable Financial Cloud, an intuitive and visual analytics platform that complies with national regulatory standards.",
      },
      publisher: {
        title: "Publisher",
        subtitle:
          "Keep readers focused and hundreds of millions of users in control.",
      },
      medical: {
        title: "medical",
        subtitle: "A medical system that satisfies patients.",
      },
    },
    customer: {
      title: "Authing's Representative Customers",
    },
  },
  detail: {
    "label-medical": "Medical",
    "label-government": "Government",
    "label-education": "Education",
    "label-finance": "Finance",
    "label-game": "Game",
    "label-software": "Software",
    "label-publisher": "Publisher",
    "title-challenge": "Demand challenge",
    "title-value": "Programme Value",
    "button-consult": "Solution consultation",
    medical: {
      title: "Medical Solution",
      sub:
        "Unified digital identity helps medical industry realize digital transformation",
      challenges: {
        "item-one": {
          title: "Protect data privacy, enhance patient trust",
          content:
            'The personal data of citizens are scattered in countless medical systems, which can easily cause the leakage of personal information. Since the "Administrative Measures for Information Disclosure of Medical and Health Service Units (Trial)" was passed in 2010, it has stipulated that the health and traditional Chinese medicine administrative departments of local people\'s governments at or above the county level shall establish and improve the accountability system for information disclosure of medical and health service units, and Supervise, manage and punish "disclosure of information that should not be disclosed, or deliberate the disclosure of the identification information of service objects and personal privacy.',
          icon: "icon authing-icon authing-weisheng icon-style",
        },
        "item-two": {
          title: "Poor medical experience",
          content:
            "In the medical system, all citizens have separate accounts. This not only means that patients need to log in with different accounts and passwords repeatedly in multiple medical institutions, but also means that personal allergy history, medical insurance records, etc. are stored in different systems, resulting in the fragmentation of personal data by the system.",
          icon: "icon authing-icon authing-duochongshenfen icon-style",
        },
        "item-three": {
          title: "Poor medical staff experience",
          content:
            "It is also difficult for the staff of medical units to access the medical system. They need to remember different passwords in each system, such as the registration system, charging system, inpatient system, pharmacy system, medical equipment system, etc. Moreover, with the increasing number of systems and the continuous change of medical personnel, it is also a difficult task to manage the identity of all personnel. Each change means that the system needs to be added, deleted, modified, and checked again and again.",
          icon: "icon authing-icon authing-butongxitong icon-style",
        },
        "item-four": {
          title: "Scalability and security of the medical system",
          content:
            "Whenever the medical system needs to integrate medical services with new cooperative units, it is necessary to redevelop new interfaces in order to barely enhance the expansion ability, and the expanded service interfaces are difficult to meet the identity security standards.",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Protect data privacy, enhance patient trust",
          content:
            'When processing personal information, authing adopts data encryption and unified management to ensure the data security and data sovereignty of patients, so that any medical system can quickly comply with the "management measures for information disclosure of medical and health service units (Trial)", protect the data privacy of patients and enhance the trust of patients on medical services.',
          icon: "icon authing-icon authing-shujuyinsi icon-default",
        },
        "item-two": {
          title: "Digital medical experience that everyone loves",
          content:
            "Patients do not need to remember the password, or just remember a password, can log into each medical system, so that patients no longer need to forget the password and delay the disease. Moreover, medical institutions do not need to develop or operate and maintain. They can open their faces and fingerprints on one key, or login in to any medical system by Alipay or WeChat.",
          icon: "icon authing-icon authing-yiyuan icon-default",
        },
        "item-three": {
          title: "Unifying medical system to reduce pressure for medical staff",
          content:
            "Authing unifies all personnel and software in the medical system. No matter where employees store it, no matter who developed the software (even old software), authing can easily connect any user and application. Authing optimizes the digital experience of medical practitioners.",
          icon: "icon authing-icon authing-tongyixitong icon-default",
        },
        "item-four": {
          title:
            "Starting from the medical system, expanding the human-centered smart city",
          content:
            "Authing can integrate patients in different hospitals and medical systems, create a unified identity experience, and manage all people in different health systems. Patients can access their health records with an account, test results with a card, and so on. This kind of medical experience will be the breakthrough point of urban modernization and digitization. Using Authing, the city can start from the medical system, integrate high-quality login experience and efficient citizen governance into any city service, and build a smart city with people as the center.",
          icon: "icon authing-icon authing-zhihuichengshi icon-default",
        },
      },
    },
    game: {
      title: "Game Solution",
      sub: "Make safe and explosive games",
      challenges: {
        "item-one": {
          title: "Security and user experience cannot be balanced",
          content:
            "Simple login design and easy authentication process do not mean sacrificing user experience and leaving no security risks",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "Difficulty in access control",
          content:
            "There are groupings in various formats in multiplayer games, and permission control becomes particularly difficult. The permission issue makes every game company a headache.",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-three": {
          title: "The higher the willingness to pay, the more game fraud",
          content:
            "With the continuous development of the gaming industry, people's electronic games have become longer and longer, and their willingness to pay has become higher. At the same time, fraud in the game has become more serious, and users' property interests are easily violated.",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-four": {
          title:
            "User system development cycle is long, affecting the online game",
          content:
            "User system and identity authentication are not the core of development, but they are also a very important link. Lengthy user system development time will greatly delay the launch time of the game.",
          icon: "icon authing-icon authing-zhouqi icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Keep it safe and have fun",
          content:
            "Authing does not allow companies or developers to choose between security and user experience. You can configure the two-step authentication strategy and choose the authentication method that suits your users.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-two": {
          title: "Identity authentication, from complex to simplified",
          content:
            "Authing can be easily implemented in any heterogeneous environment, no matter what language or technology stack. Authing provides software development kits (SDKs) and application interfaces (APIs) in 10+ mainstream languages, and it is convenient for you to quickly deploy Authing in public or hybrid clouds.",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-three": {
          title: "Authority management, flexible and powerful",
          content:
            "RBAC and ABAC-based permission control are more flexible and powerful. The permissions of each user are controlled by the roles you create.",
          icon: "icon authing-icon authing-management icon-default",
        },
        "item-four": {
          title: "Rapid deployment, speed up the game",
          content:
            "Quickly deploy the identity link, speed up the game launch, reduce development man-hours related to certification by 51%, and reduce operation and management time by 200 hours.",
          icon: "icon authing-icon authing-Smooth icon-default",
        },
      },
    },
    software: {
      title: "Technology Solutions",
      sub: "Improve development efficiency by at least five times",
      challenges: {
        "item-one": {
          title: "Low development efficiency and serious cost waste",
          content:
            "Product development is very slow. Every time we develop an application, we have to develop a user system, and the implementation is complex, and the ability to face different scenarios is not the same, and both time and labor costs are highly wasteful.",
          icon: "icon authing-icon authing-highcost icon-style",
        },
        "item-two": {
          title: "Security faces huge challenges",
          content:
            "With the increase of security risks, errors in the management of identity authentication users are often fatal. At present, there are security and authentication professionals who can master various authentication protocols. It is rare, expensive and expensive.",
          icon: "icon authing-icon authing-Safety icon-style",
        },
        "item-three": {
          title: "Missed growth opportunities",
          content:
            "In the application matrix, different platforms will be developed, which will cause our users to be scattered among the platforms with different login methods, and even need to attract each other's different products, leading to missed growth opportunities.",
          icon: "icon authing-icon authing-jihui icon-style",
        },
        "item-four": {
          title: "Expensive maintenance costs",
          content:
            "Cloud technology, artificial intelligence, big data, identity and many other technologies continue to be updated, and the internal system update speed to be equal to the industry requires expensive maintenance costs and continuous development and innovation capabilities, as well as more time and labor costs.",
          icon: "icon authing-icon authing-low-cost icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Accelerate product landing and reduce development costs",
          content:
            "Authing accelerates product research and development, speeds up business launches, reduces certification-related development man-hours by 51%, reduces operation and management time by 200 hours, allows products to be quickly implemented and realizes business value.",
          icon: "icon authing-icon authing-low-cost icon-default",
        },
        "item-two": {
          title: "Eliminate identity risks, safe and trustworthy",
          content:
            "To hedge against security risks, professional matters should be entrusted to professional people, and the identity link should be entrusted to professional people to hedge security risks. Multi-factor authentication (MFA) functions such as dynamic tokens and face recognition are available to you instantly, out of the box, and trustworthy.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-three": {
          title: "Increasing corporate income, the software generates value",
          content:
            "Promote business growth, centrally manage users from all sources, and increase user experience to create cross-selling opportunities, increase corporate revenue, and achieve customer success.",
          icon: "icon authing-icon authing-value icon-default",
        },
        "item-four": {
          title: "Continuous innovation and iteration, identity out of the box",
          content:
            "Provides a cross-platform, 10+ language software development kit (SDK) and the application interface (API), which can quickly and safely integrate user authentication into various applications. Have a professional team to carry out product version iteration and innovative technology updates, and quickly synchronize to all users。",
          icon: "icon authing-icon authing-chuangxin icon-default",
        },
      },
    },
    government: {
      title: "Government Solutions",
      sub: "Smart government brings convenience to the people",
      challenges: {
        "item-one": {
          title: "Data isolation, decentralized security",
          content:
            "Identity data is scattered on different platforms, and each department has its own departmental system and process. In government affairs, different systems and processes will reduce the coordination and organization of work and greatly reduce work efficiency and coordination.",
          icon: "icon authing-icon authing-shujufensan icon-style",
        },
        "item-two": {
          title: "High maintenance costs and limited functions",
          content:
            "Cloud technology, artificial intelligence, big data, identity and other technologies continue to be updated. Synchronous updates of government internal systems require expensive maintenance costs and continuous development and innovation capabilities. At the same time, many functions are restricted due to technical reasons.",
          icon: "icon authing-icon authing-highcost icon-style",
        },
        "item-three": {
          title: "The deployment environment is complex",
          content:
            "Different software deployed in different cloud environments will face intricate management situations such as multi-cloud and hybrid cloud, which will make management extremely difficult.",
          icon: "icon authing-icon authing-deploy icon-style",
        },
        "item-four": {
          title: "Citizen experience needs continuous improvement",
          content:
            "Serving people is the primary task of governments at all levels. At the same time as the digital reform of the government, the user experience of citizens has also become an important challenge. It is necessary to provide citizens with more flexible digital services and fast online services. At the same time, it is necessary to consider the needs of citizens of different ages, different attributes, and different businesses, so that digital government services can provide a quality life for every citizen.",
          icon: "icon authing-icon authing-userexperience icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Quick deployment, smooth and non-sense",
          content:
            "The Authing platform is ready to use, and automatically installs and updates. It only takes a few hours to build a new government software based on Authing, or to connect old software to Authing, without repeated programming and provides a software development kit (SDK) and the application interface (API) in 10+ languages.",
          icon: "icon authing-icon authing-Smooth icon-default",
        },
        "item-two": {
          title: "Multiple security, trustworthy",
          content:
            "After conducting a lot of research on data security supervision technology, Authing has improved the monitoring, discovery and processing capabilities for security risks such as illegal cross-border data flows, and adopted global MFA to improve overall security. On the one hand, the login environment is constantly monitored to make all government applications more secure; on the other hand, to increase the usability of users, even if they forget their passwords, fingerprints, SMS, dynamic passwords, face recognition, etc. can be used as authentication factors.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-three": {
          title: "One software, global monitoring",
          content:
            "Centralized control of user behavior information and portrait information when accessing government services. Through big data technology, it can realize cross-domain and cross-channel comprehensive analysis, explore the people's government needs, and improve the quality and efficiency of government services.",
          icon: "icon authing-icon authing-monitor icon-default",
        },
        "item-four": {
          title: "Collect once, work smoothly",
          content:
            'Users centrally manage personal information and authorize to fill in forms to realize the smooth operation of the "One Number" of the masses, avoid repetitive submission of personal information and service materials to departments and institutions, and realize the diversified collection, intercommunication and sharing of basic user information, and multi-party utilization.',
          icon: "icon authing-icon authing-acquisitionModality icon-default",
        },
      },
    },
    finance: {
      title: "Financial Solutions",
      sub:
        "Help financial services companies of all sizes accelerate innovation and improve user experience.",
      challenges: {
        "item-one": {
          title: "User experience not to be ignored",
          content:
            "Consumers with keen eyes have higher and higher standards for user experience. Whether they log in to the user system or purchase financial products, user experience is the foundation of all quality services.",
          icon: "icon authing-icon authing-tiyan icon-style",
        },
        "item-two": {
          title:
            "Cooperation between departments is blocked, and authority management is difficult",
          content:
            "Most financial institutions have many business sectors, each with its own systems and services. This usually leads to a decrease in communication and coordination efficiency between departments, which affects the business efficiency of the company. Multi department management becomes a great challenge for different organizations.",
          icon: "icon authing-icon authing-hinder icon-style",
        },
        "item-three": {
          title:
            "The development is difficult and the security is facing great challenges",
          content:
            "In the financial services industry scenario, the user system, the identity authentication link is complex, the development difficulty is greatly increased, and a large number of sensitive scenarios will be involved. In the security link, there will be a lot of challenges, and the identity link is the top priority. Any error is often fatal.",
          icon: "icon authing-icon authing-kaifa icon-style",
        },
        "item-four": {
          title:
            "There are many employees involved in the system, so it is difficult to manage",
          content:
            "Every financial industry staff needs to involve more than a dozen or even dozens of software tools. Every time an employee enters or leaves the company, he or she has to face the problem of account management. Whether it is processing time or information security, it needs to be improved.",
          icon: "icon authing-icon authing-xitong-2 icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Unforgettable customer experience",
          content:
            "Discerning consumers have a high standard of user experience, whether they log in to check to bank or buy their favorite insurance. User experience has become the cornerstone of many of today's digital transformations, and it all starts with identity. Enable single sign-on to provide a true Omnichannel experience.",
          icon: "icon authing-icon authing-tiyan icon-default",
        },
        "item-two": {
          title: "Help complete digital transformation",
          content:
            "Set identities once and for all to speed up innovation. Authing is designed to connect any employee, supplier, partner and user with any application, ensuring security while improving ease of use, and easily integrating with your existing systems.",
          icon: "icon authing-icon authing-zhuanxingjia icon-default",
        },
        "item-three": {
          title: "Multiple identity sources, click to use",
          content:
            "Fast integration of social login mode, multi identity source. Common third-party login methods, such as WeChat, nail, microblog, etc. In Authing, you just need to click to use it.",
          icon: "icon authing-icon authing-duozhong icon-default",
        },
        "item-four": {
          title: "Trusted enterprise security",
          content:
            "Dynamic token, face recognition, and other multi-factor authentication (MFA) functions enable you to have them immediately and use them out of the box, which can comprehensively improve the system access security, guarantee the user transaction security and improve the user experience.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
      },
    },
    publisher: {
      title: "Publishing Solutions",
      sub: "Three-dimensional publishing experience",
      challenges: {
        "item-one": {
          title: "Missed growth opportunities",
          content:
            "In the application matrix, different platforms will be developed, and users need multiple accounts to log in to different platforms. As a result, our users will be scattered in various platforms, and even need to conduct mutual drainage among their different products, resulting in missed growth opportunities.",
          icon: "icon authing-icon authing-opportunity-growth icon-style",
        },
        "item-two": {
          title:
            "The development efficiency is low and the cost is wasted seriously",
          content:
            "Product research and development is very slow. Every time we develop an application, we have to develop a user system, and the implementation is complex. Facing different scenarios, we need different capabilities. It is a high waste of time cost and human cost.",
          icon: "icon authing-icon authing-highcost icon-style",
        },
        "item-three": {
          title: "Miscellaneous authority management",
          content:
            "A large number of editors need to edit various categories of books online, which requires complex authority control and approval process.",
          icon: "icon authing-icon authing-tushuguanli icon-style",
        },
        "item-four": {
          title: "Security faces great challenges",
          content:
            "Many users need to purchase and read books online. Security will face great challenges, identity will be the first line of defense, identity authentication user management errors are often fatal.",
          icon: "icon authing-icon authing-Safety icon-style",
        },
      },
      values: {
        "item-one": {
          title: "Give readers a real ultimate experience",
          content:
            "Reading books is a process of nutrition supplements. In the process of nutrition supplements, it is a painful process for students to repeatedly input their passwords. Single Sign-on helps students focus on reading instead of account and password, log in only once, and enjoy all services.",
          icon: "icon authing-icon authing-Smooth icon-default",
        },
        "item-two": {
          title: "Make security trustworthy",
          content:
            "When students buy books in a publishing house, these accounts will also become a cake to attract criminals. Compared with single password authentication, multi-factor authentication such as dynamic password and face recognition is a better security upgrade.",
          icon: "icon authing-icon authing-Safety icon-default",
        },
        "item-three": {
          title: "Hundreds of millions of users",
          content:
            "When the peak comes, the login interface will hang up and new users can't register, which will cause a fatal blow to your business. Authing will automatically scale at the peak, contributing to business success.",
          icon: "icon authing-icon authing-user icon-default",
        },
        "item-four": {
          title: "Distribution, author, editor, authority in control",
          content:
            "Publishing House involves many roles, such as topic selection committee, editor, hairstyle, author, etc. each role has different permissions and groups. The RBAC permission control scheme provided by Authing can easily control all roles.",
          icon: "icon authing-icon authing-multiple-roles icon-default",
        },
      },
    },
    education: {
      title: "Education solutions",
      sub:
        "Provide simple, centralized and secure identity and access management for all important campus user groups",
      challenges: {
        "item-one": {
          title: "Campus information security facing challenges frequently",
          content:
            "Schools often suffer from network attacks, and the privacy of students' status information is greatly enhanced. There is endless news of students' information leakage, and the students and their parents who have been leaked are frequently bombarded with junk messages through sales calls.",
          icon: "icon authing-icon authing-anquan1 icon-style",
        },
        "item-two": {
          title: "Old software costs a lot",
          content:
            "The old software of the school still consumes the maintenance cost, and the school needs to be modernized urgently. In the face of checking scores, online large-scale live conferences, often face server downtime, student parents' login failure, and other peak fluctuations, leading to a significant decline in the sense of experience.",
          icon: "icon authing-icon authing-Consume icon-style",
        },
        "item-three": {
          title: "The demand for authority management is imminent",
          content:
            "The user roles in education scenarios have a long cycle and a large number of changes. They are faced with the challenge of authority control between cycles. Different roles will face multiple authentication scenarios.",
          icon: "icon authing-icon authing-management icon-style",
        },
        "item-four": {
          title: "Difficulties in digital transformation",
          content:
            "It is difficult to have a perfect cross-platform, multi-functional SDK, and API in various languages. Some of them can not even become a unified identity source by themselves. They do not have any business and technical expansibility, which hinders the implementation and deployment of new technologies and applications in the future and makes the school lose its digital foresight and competitiveness. Due to the school's demand for the customized login process and brand UI, most of the unified identity management platforms still rely on consuming huge human resources to do secondary customized development, which can not quickly realize UI configuration.",
          icon: "icon authing-icon authing-zhuanxingjia icon-style",
        },
      },
      values: {
        "item-one": {
          title:
            "Integrate all educational resources to make knowledge accessible",
          content:
            "Libraries, science and technology museums, museums and other digital knowledge are stored in their own systems, and there is a distance from each student. Authing should get through the distance between all digital education resources and students. Let the student through an account, through a screen can obtain any knowledge he needs.",
          icon: "icon authing-icon authing-jiaoyuziyuan icon-default",
        },
        "item-two": {
          title: "7*24，Protect students' information security",
          content:
            "Each functional department of the school contains a large number of sensitive data, so safe operation is very important. Authing constructs an all-round, multi-level, and perfect identity security system, which can ensure data security on the basis of network security. According to the design requirements of infrastructure and various application systems, different security policies and measures are adopted to ensure system security. Authing ensures that each user can and can only access the corresponding information resources and application services through identity authentication, role definition, and permission allocation. It is a user management platform that can be used, checked, and tracked within 7 days * 24 hours to protect students' information security.",
          icon: "icon authing-icon authing-xinxianquan icon-default",
        },
        "item-three": {
          title: "It is easy to operate without maintenance",
          content:
            "Excellent teachers are the most valuable asset of every school. Their enthusiasm, motivation and enthusiasm can inspire and attract students and ultimately make them achieve the most. Authing makes the user management system clear structure, friendly interface, simple operation and no maintenance. Let every teacher put all his energy on the students, no longer troubled by the maintenance system.",
          icon: "icon authing-icon authing-caozuo icon-default",
        },
        "item-four": {
          title: "Everything is set as you wish, not just UI and domain name",
          content:
            "The authing user login component helps developers avoid a lot of implementation details of low-level authentication, including tedious UI development. It is an embedded login form, which can be customized according to the needs of different schools. Provide cross-platform, 10 + language software development kit (SDK) and the application interface (API), can quickly and safely integrate user authentication into various applications.",
          icon: "icon authing-icon authing-sheding icon-default",
        },
      },
    },
  },
  wechat: {
    banner: {
      title: "Wechat Ecological Solution",
      subtitle:
        "Authing quickly realize the identity authentication and user management of any web, app and enterprise software, and provide the most perfect login solution for your customers and employees.",
    },
    "mini-login-scan": {
      title: "Scan small login QR code for login",
      content:
        "This is a pioneering design of Authing. In authing, the scanning small login QR code can be opened to obtain the official real name user information of wechat. The user can complete the registration / login with the real number by one click authorization, thus establishing an account system based on mobile phone number for developers.",
    },
    "pc-scan-login": {
      title: "PC scan login",
      content:
        "Wechat PC scanning login enables wechat users to use wechat identity to log in to third-party applications or websites safely. After the wechat code scanning login is opened in Authing, wechat users' basic open information can be quickly obtained and basic open functions can be realized.",
    },
    "web-authorize": {
      title: "Wechat website authorization",
      content:
        "Authing provides a way for users to quickly log in to the website through wechat. If users visit third party web pages in WeChat client, official account can get basic information from WeChat users through the authorization mechanism of WeChat website, and then achieve business logic.",
    },
    "mini-program-login": {
      title: "Login in wechat applet",
      content:
        "Authing provides developers with a way to quickly obtain user information and complete login through SDK. Through authing's SDK, we can easily obtain the user's identity provided by wechat, and quickly establish an account system based on mobile phone number.",
    },
    "mobile-login": {
      title: "Mobile end pull up wechat login",
      content:
        "Authing provides a way for developers to quickly jump to wechat login to obtain user information in mobile terminal (IOS or Android) applications. Wechat account access can be completed by simply calling the Authing Mobile SDK.",
    },
    "mobile-mini-program-login": {
      title: "Mobile end pull up applet login",
      content:
        "The mobile terminal pull up the small program login is the key way to establish the mobile terminal user system with mobile phone number as the center. Authing greatly reduces the development complexity by using SDK. A line of code can obtain the mobile phone number authorized by the user in the applet through the mobile terminal, and establish an account system based on the mobile number.",
    },
  },
  IDaaS: {
    title: "IDaaS has replaced traditional IAM",
    subtitle:
      "With the rapid development of digital transformation and cloud computing, the dimensions and boundaries of enterprise information security are becoming more and more complex. As the first door, identity authentication and access rights management are carrying a very critical mission",
    navList: {
      title1: "IDaaS / IAM definition",
      title2: "Operational capability",
      title3: "Scalability",
      title4: "Security",
      title5: "About Authing",
    },
    explaination: {
      overview1:
        "With the rapid development of digital transformation and cloud computing, the dimensions and boundaries of enterprise information security are becoming more and more complex. As the first door, identity authentication and access rights management carry a very critical mission.",
      overview2:
        "In this context, the disadvantages of traditional IAM are gradually exposed: it is difficult to ensure access security in the hybrid cloud environment; it is not competent in the internal staff management and external user management scenarios; it is not flexible enough to launch new applications and compatible with old applications. At the same time, IDaaS service has the advantages of cloud scalability and cross-environment identity recognition and rights management capabilities, replacing the traditional IAM as enterprise infrastructure.",
      IDaaSDefine: {
        title: "Definition of IDaaS",
        subtitle:
          "IDaaS is the abbreviation of identity as a service. It is a managed IAM service built and maintained by a third-party service provider. IDaaS contains all the functions of traditional IAM and can bring more benefits to enterprises",
        item1: "Improve marketing and efficiency",
        item2: "Accelerate the launch of new business",
        item3: "security and reduce network attack risk",
        item4: "Enhance user experience",
      },
      iamDefine: {
        title: "Definition of IAM",
        imgText: "IAM core functions",
        subtitle1:
          'IAM is the abbreviation of identity and access management, namely identity authentication and access management. Gartner, a technology consulting firm, defines IAM as "letting the right people access the right resources at the right time and for the right reasons."',
        subtitle2:
          "Therefore, traditional IAM providers are also known as 4A vendors. They integrate existing systems for enterprises and build an integrated application platform integrating user management, identity authentication, privilege management, and audit.",
      },
    },
    operate: {
      title: "Operational capability",
      description1:
        "For example, it is difficult for IAM to find out the business opportunities of large-scale customers who have not signed in to IAM within six months, and it is difficult for them to find out the business opportunities of customers who have not signed in to IAM in six months and have not been able to meet the needs of their customers.",
      description2:
        "Similar scenarios are almost everywhere in the daily operation of enterprises, but the traditional IAM does not have such flexible functions. The multi-tenant operation platform and workflow of IDaaS can easily realize such operations, and the efficiency of enterprise operation can be greatly improved.",
    },
    expend: {
      title: "Scalability and scalability",
      description1:
        "When the number of users is increasing, the pressure on the user system will also increase. The traditional IAM mainly relies on accumulating servers and setting load balancing to optimize, but the number of login failures always increases with the increase of users, which is a disaster for enterprises and users.",
      description2:
        "The cloud-native architecture of IDaaS can solve this problem well. Take the authentication identity cloud IDaaS for example, nearly ten million users log in to thousands of systems through Authing every month, and have large-scale data processing experience. The digital identity solutions built by third-party IDaaS platforms like Authing can better support enterprise expansion.",
      description3:
        "Another problem that enterprises often encounter is to continuously access new systems and develop new applications. And every time you go online, you need to get through with the user center to realize single sign-on (SSO), which is a complex task for IAM, and even the vast majority of IDaaS on the market are difficult to support flexibly. The developer-friendly IDaaS like Authing makes it easy for developers to access new applications and be compatible with old applications by encapsulating more than 500 APIs and SDKs in more than 10 languages. Help new businesses go online quickly.",
    },
    security: {
      title: "Security",
      description1:
        "Data assets are gradually surpassing physical assets and becoming the most valuable core of enterprises. The theft and attacks against data assets are also on the rise. Traditional IAM is built locally, which is difficult to guarantee enterprise security in the hybrid cloud environment. The granularity of privilege management is coarse and the access control policy is single.",
      description2:
        'For example, when an employee changes his / her common login address or changes his / her frequently used login device, the risk of the member\'s account being stolen will increase. The traditional IAM will take back all his / her permissions in a "one size fits all" way. However, a better way is to double verify the user through other methods such as face or fingerprint. After confirmation, the user is authorized according to the preset policy and authorized in IDaaS In the platform, attribute-based access control (ABAC) allows enterprise IT personnel to configure similar policies easily and flexibly.',
      description3:
        "The security of third-party cloud services has been questioned, but more and more data show that cloud services have higher security than locally deployed software, and the same is true of IDaaS compared with IAM. The domestic IDaaS platform represented by Authing uses KMS encryption technology to make the managed data only accessible by the owner.",
      description4:
        "Moreover, Authing also provides private cloud solutions, which enable enterprises to enjoy the advantages of cloud-native products and avoid risks.",
    },
  },
  okta: {
    title: "Move from Okta",
    subtitle:
      "By comparing with Okta from six dimensions of identity platform, workflow, directory, application integration, user analysis, and development components, it can be seen that Authing is the only identity service provider that can replace Okta",
    navList: {
      title1: "Introduction to Okta",
      title2: "Replace Okta with Authing",
      title3: "Comparison of manufacturers",
      title4: "About Authing",
    },
    intro: {
      title: "Introduction to Okta",
      description1:
        "Okta, founded in 2009, is a San Francisco based provider of identity and access management solutions. It was listed on NASDAQ in 2017. At present, Okta has nearly $400 million in revenue, 1300 employees, and 5600 customers. It has offices in 10 cities in five countries, including Toronto, London, Amsterdam, and Sydney, Australia, with more than 100 million registered users.",
      description2:
        "Aaron Levie, CEO of Box company in the United States, once praised Okta as a great driving force for the world to transform into cloud services. This is because Okta provides a solution to complex identity identification and access management in enterprises, that is, single sign on, Okta The cloud platform is similar to a password manager, which can provide a convenient application access experience for enterprise employees and customers.",
      description3:
        "Okta's success depends on seeing the future development trend and entering the market at the right time. At present, Okta's performance is still maintaining rapid growth, and its market is also growing rapidly. It is expected that the target market size will reach 30 billion US dollars.",
      incomeLabel:
        "At present, Okta's revenue is nearly 400 million US dollars",
      employeeLable: "Number of employees",
      customerLabel: "Number of customers",
      registerLabel: "Number of registered users has exceeded 100 million",
    },
    replace: {
      title: "Using Authing to replace OKTA in China",
      description1:
        "Because Okta does not provide local services in mainland China, it is very slow and unstable to visit Okta in China. For enterprises who want to use such IDaaS services like Okta in China, Authing identity cloud, Yufu, and Jiuzhou Yunteng are currently the leading identity solution providers in China.",
      description2:
        "By comparing with Okta from six dimensions of identity platform, workflow, directory, application integration, user analysis, and development components, it can be seen that Authing is the only identity service provider that can replace Okta.",
    },
    compare: {
      okta: "Okta",
      authing: "Authing",
      yvfu: "Yufu",
      jiuzhou: "Jiuzhou Yunteng",
      item1: {
        title: "Identity platform",
        subtitle: "Authentication, authorization and registration",
      },
      item2: {
        title: "Workflow",
        subtitle: "Configure identity centric business processes",
      },
      item3: {
        title: "Catalog",
        subtitle: "Store users and attributes, more flexible and expandable",
      },
      item4: {
        title: "Application Integration",
        subtitle:
          "Integrating customer application ecology through Identity Protocol",
      },
      item5: {
        title: "User analysis",
        subtitle:
          "Summary: analysis of user data, provide strategies for malicious IP security protection",
      },
      item6: {
        title: "API、SDK and other development components",
        subtitle:
          "Support customers to carry out secondary development flexibly according to actual needs",
      },
    },
  },
  ad: {
    title: "Move AD to Cloud",
    subtitle:
      "This is why visionary IT organizations want to integrate their old AD environment with modern SSO in Authing. The integration with Authing provides a gateway that can easily and securely connect your employees to many services and resources they want to use",
    navList: {
      agent: "Authing active directory agent",
      function: "AD agent integration functio",
      interval: "Active / Long polling",
      connection: "AD proxy connection",
      management: "AD agent work management",
      integrate: "Use Authing to plan AD integration",
      authentication: "User authentication",
      import: "User import job",
      synchrony: "Real-time synchronization job",
      install: "Install AD agent",
      mix: "Fusion and harmony",
    },
    agent: {
      title: "Authing active directory agent",
      overview1:
        "Active Directory (AD) has been around since 1999 when Microsoft first released it with Windows 2000 Server. Over the years, it has become a key local service for managing identity-based related activities. But as the demand for cloud services and applications has grown, organizations have begun to realize that AD is not built for the cloud-centric world and today's use cases. Nevertheless, they still want a way to leverage their investment in AD and take advantage of modern single sign-on (SSO) to access all their cloud and local applications and resources through a single interface, while reducing management overhead.",
      overview2:
        "This is why visionary IT organizations want to integrate their legacy AD environment with modern SSO in Authing. The integration with Authing provides a gateway that can easily and securely connect your employees to many services and resources they want to use. To help you plan and implement the integration, this article provides you with insights into the functional and operational aspects of the integration from AD to Authing.",
      text1:
        "The Authing AD agent is the core of the integration between AD and Authing. It provides an interface between Authing and the local AD instance. The design of Authing and proxy is extensible in nature, so it is easy to add more users and deploy more proxies as needed. The agent uses secure outbound communication, provides load balancing and job management through long polling, and uses long-term authorization to refresh tokens.",
      text2:
        "You install the agent on a dedicated local member server in the AD domain. Under no circumstances should the agent be installed on the domain controller, because if you need to restart or reinstall the agent, it will affect the domain controller.",
    },
    function: {
      title: "AD agent integration function",
      overview1:
        "The AD agent provides two main functions. The first is delegated authentication, which allows your local AD instance to continue to be the source of authentication. Through delegated authentication, all passwords are kept in AD, and AD determines whether users can access Authing.",
      overview2:
        "Every time a user tries to access a resource through Authing, Authing will route those authentication attempts to the local AD directory. After authentication, AD allows Authing to grant users access to Authing and assigned resources.",
      text1:
        "The second main function of the agent is to import users and groups with relevant attributes from AD to Authing. The import process creates a new user object in Authing for each user object that exists in the AD organizational unit (OU) you specify.",
      text2:
        "Authing then links the respective AD and Authing users together. This allows Authing to manipulate and enhance user attributes of objects stored in its universal directory as needed, without affecting user objects stored in AD.",
      text3:
        "You can also bring your users to Authing, which allows you to take advantage of Authing’s feature set, such as providing centralized SSO for any resources your users need, whether they reside on-premises or in the cloud.",
    },
    internal: {
      title: "Active / Long polling",
      overview1:
        "Authing deploys the AD agent in an active/active configuration without a primary agent or secondary agent. Therefore, there is no need to actively load balance the agents. All deployed agents are always active and use long polling to continuously find new jobs as their ability to handle these jobs allows.",
      overview2:
        "Therefore, using our long polling model, Authing no longer waits for requests from the agent as in the traditional client-server relationship but continues to push jobs to the job pool, and the agent gets them as soon as possible. Since the job is almost immediately taken away, compared with the traditional model, the waiting time can be saved and the job can be processed faster.",
      "img-text-interval": "Active / Long polling",
      "img-text-connection": "AD proxy connection",
    },
    connection: {
      title: "AD proxy connection",
      overview:
        "The Authing AD proxy uses certificate pinning with TLS server authentication to create an outbound HTTPS connection to the Authing identity cloud. Each connection lasts no more than 30 seconds. During this connection time, the AD agent will listen to events from the Authing service that it can handle, such as AD authentication events. If such an event occurs, the AD agent will catch it for processing and close the connection. Then, the AD agent will immediately open a new connection and listen for new jobs again. If no event occurs during the 30-second window of the connection, the agent will close the connection and start a new 30-second connection to listen for another job.",
    },
    management: {
      title: "AD agent work management",
      overview1:
        "Since authentication jobs are usually small jobs that need to be processed quickly, and import jobs are large jobs that take more time, Authing uses different workload distribution methods for each job type. Authing can better adapt to inherent differences in work types. Any available agent can handle authentication tasks. Therefore, Authing randomly selects an agent from the pool of available agents for each authentication task.",
      overview2:
        "The import job uses the preferred proxy. Although the initial agent assignment is random, Authing will continue to use the agent to perform subsequent tasks until the agent becomes overwhelmed or unavailable. At that time, Authing will assign other agents to handle import tasks.",
      overview3:
        "By default, Authing configures each agent with two threads. However, if necessary, you can configure up to 10 threads for the agent to solve the agent's needs. Generally, there is always a thread in the agent that can be used to handle authentication tasks. For example, when an agent gets a publish import job, Authing will not send any other import jobs to the agent before the job is completed, but the agent's second thread can still be used to accept authentication jobs.",
      block1: {
        title: "Example authentication job",
        item1: "The job thread remains open for 30 seconds",
        item2: "The agent executes HTTP GET to get the job from Authing",
        item3: "The proxy receives the authentication job from Authing",
        item4: "The agent performs authentication operations",
      },
      block2: {
        title: "Example of an import job being performed",
        item1: "The job thread remains open for 30 seconds",
        item2: "The agent executes HTTP GET to get the job from Authing",
        item3: "The agent receives the import job from Authing",
        item4: "Agent performs import operations",
        item5: "Agent becomes the preferred agent for import jobs",
      },
    },
    integrate: {
      title: "Use Authing to plan AD integration",
      overview:
        "When planning and establishing integration, it is important to understand the difference between user authentication capabilities and user import. For example, the frequency of these job types and their user groups have different effects on the operability of your AD integration with Authing. Similarly, the importance of knowing when the user base performs each type of job is as important as understanding the size of the user base, or even more important. To help you with integration planning and construction work, the following content provides some additional details for each job type, including the differences in how each job type works.",
    },
    authentication: {
      title: "User authentication",
      overview1:
        "When users enter their credentials in the Authing user interface for authentication, Authing will determine whether they are the primary AD user. If they are AD master users, Authing will add their authentication request to the job list associated with the user's directory instance. After adding the authentication job to the job list, Authing will randomly assign the job to any available AD agent polling job, and then the assigned agent will open the job on the server running the agent. AD master user refers to the user whose original attribute is owned by the AD instance.",
      overview2:
        "Next, the AD agent uses the user name format specified in the AD integration settings (for example, user principal name (UPN)) to look up the user. After the agent finds the user, it will perform BIND on the AD instance using the credentials entered by the user. The following is an example of a UPN query that the agent can use to find a user:",
      overview3:
        "Compared with user import, user authentication can be performed quickly. After completing the integration settings, the agent can begin to perform a lot of authentication. As needed, you can deploy multiple other agents in the integration to allocate more resources for authentication.",
      overview4:
        "One of the reasons for deploying other agents for authentication may be to better handle seasonal trends. For example, retail stores often experience large upward fluctuations during the holidays. The need for high availability is another reason why organizations often deploy other agents for authentication.",
      overview5:
        "Besides, global organizations often deploy other AD agents in locations close to their different geographic locations. Deploying AD agents on member servers that are very close to the domain controller or domain controller pool can reduce the delay during authentication. As mentioned earlier, it is important to ensure that the AD agent is deployed only on dedicated member servers and not on domain controllers.",
    },
    import: {
      title: "User import job",
      overview1:
        "User import can be initiated by scheduled import or manual import. Both methods create a job in Authing and assign the job to the preferred agent. Like the authentication job, the AD agent will contact Authing, pull down the job, open it on the local server running the agent, and execute the job. The agent first performs topology reading of the entire AD structure. The agent will then update users and groups. If it is an incremental import, it will perform the import based on the usnChanged AD attribute value read for each object. *The range of objects read will be based on the import settings of the AD agent. The content configured in the AD integration settings of the Authing tenant.",
      tip: "The following is an example of an import job query:",
      overview2:
        "It is important to remember that once the server has run the import, it will become the preferred import server. This means that subsequent import jobs will be sent to the same server. Therefore, if the AD agent is deployed on multiple servers, the import job will not be scattered on all these servers. Instead, they will only be executed on the current preferred server.",
      overview3:
        "In addition, it is important to understand that the import speed depends on the size of the catalog, the scope, and frequency of the import. For example, if the import scope includes 10,000 OUs and millions of users have been updated since the last import, the import scope will take longer than importing 5,000 OUs and users who have not yet been updated.",
      warn:
        "Note: For more information about the usnChanged attribute of Microsoft AD, please visit",
      code: {
        read: "Topological reading",
        account: "User account read",
      },
    },
    synchrony: {
      title: "Real-time synchronization job",
      overview1:
        "In addition to user authentication and user import, if just-in-time (JIT) updates are enabled, the Authing AD agent will also perform real-time synchronization tasks. The real-time synchronization job will update user attributes, group memberships, and create new groups in Authing upon login. To this end, the agent performs BIND on a randomly selected AD server.",
      overview2:
        "After a successful BIND, the server will receive a security token containing a list of group security identifiers (SIDs) to which the current user belongs. The proxy extracts the SID from this token, uses the SID to find the group in its local SID cache, and then sends membership to Authing so that Authing can add the user to the group. If SIDs do not exist in the local cache, the agent will search for them in AD.",
    },
    install: {
      title: "Install and troubleshoot the AD agent",
      overview1:
        "You can find detailed requirements, procedures, and tasks for installing the AD agent into the AD agent integrated with Authing in Authing.cn/docs. To help you troubleshoot, Authing records the Windows Event Viewer operations performed by the AD agent in the AD agent's log. AD agent logs are stored in",
      overview2:
        "And Windows Event Viewer. If you need additional logging information, you can enable detailed logging.",
      overview3:
        "Since the AD proxy communicates with Authing via HTTPS, you can use a web monitoring tool (such as Fiddler) to capture this traffic.",
    },
    mix: {
      title: "Fusion and harmony",
      overview1:
        "By integrating AD and Authing with the Authing AD proxy, you can take full advantage of modern applications, including mobile applications, SaaS applications, and local applications. By adding these applications to Authing, you can automatically provide access to your AD users. Authing can also easily protect access to these applications through a set of central policies, adaptive multi-factor authentication (AMFA), and even the option of no password. By using our Authing RADIUS proxy and Authing LDAP interface, you can even extend some of the security functions of Authing to local network devices, such as Wi-Fi routers, VPNs, and other network devices.",
      overview2:
        "With centralized identity access management (IAM) and a single login interface, users can access all the applications and services they need, which significantly reduces management overhead, speeds up application deployment, and provides users with more seamless and consistent access rights, and Enhance overall security with more modern identity verification functions.",
      overview3:
        "In the past, AD has become an integral part of your environment and will continue to provide value in the future. However, as you leverage the many advantages of the modern IAM that Authing brings with this integration, the way you view AD roles may change. Authing opens a gateway to easily and securely access the ever-growing modern applications and services. Utilizing our vendor-agnostic nature and integrated network, you can connect to any technology through Authing to provide you with the flexibility you need to drive business innovation and success.",
    },
  },
  buildIdaas: {
    title: "Build your own IDaaS",
    subtitle:
      "As businesses accelerate their digital transformation, 「identity and access management」 is critical to their success. 「Digital identity transformation」 and 「Digital identity transformation」 can start from the solution of digital identity management.",
    need: {
      title: "Challenges faced by modern enterprises and organizations",
      subtitle:
        "In today's highly interconnected office environment, organizational teams are distributed around the world, and people use a variety of devices and applications to work. This means that enterprises must ensure a secure access environment for users on a variety of devices and platforms.",
      descript1:
        "In today's highly interconnected office environment, organizational teams are distributed around the world, and people use a variety of devices and applications to work. This means that enterprises must ensure a secure access environment for users on a variety of devices and platforms.",
      descript2:
        'For enterprises competing in the "borderless and digital world", protecting sensitive systems and customer confidential data is crucial. However, the current network security situation is not optimistic. According to Forbes, there were 4.1 billion records of data leakage in the first half of 2019 alone. In 2020, many illegal elements use enterprise security loopholes to commit cybercrimes, causing social and economic chaos.',
      descript3:
        "Protecting and utilizing digital identity information is crucial. When customer data is abused or stolen due to improper maintenance, the enterprise will not only suffer business losses but also may face huge compliance fines and other legal penalties.",
      descript4:
        "Security and identity are complementary. An identity-centric security approach can better manage people, devices and applications. Now more and more enterprises begin to use IDaaS services. These services not only help them to manage their identities efficiently but also protect their sensitive systems and confidential information from infringement.",
      descript5:
        "Investing in IDaaS will greatly help protect enterprise data from attacks, while enabling employees to work more effectively and providing more value to enterprise customers.",
      descript6:
        "Besides, according to a recent study by Zsclarer, to cope with the new epidemic in 2020, 75% of enterprises have accelerated their digital transformation plan to meet the needs of fast-growing customers, and the digital transformation will continue.",
      descript7:
        'As companies accelerate their digital transformation, they find that "identity and access management" is critical to business success. But at the same time, the implementation of identity and access management is complex and full of risks. In short, a sound identity and access management solution can determine the success or failure of a digital transformation project. A successful digital transformation project includes identity and access management solution from the beginning.',
      difficltyTitle: "Pain point",
      methodTitle: "Solutions",
      secondTitle:
        "The proportion of China's GDP and its expenditure of enterprises in the world in 2016-2019",
      secondSubtitle:
        "Note: the exchange rate of RMB against the US dollar is calculated according to the annual average exchange rate of RMB published in the statistical bulletin of national economic and social development. It expenditure, software expenditure, and service expenditure. Source: comprehensive IMF, Gartner, public data, and iResearch statistical prediction model estimation, independent research, and drawing by iResearch Consulting Research Institute.",
      secondDescript:
        'According to the data from 2016 to 2019, the proportion of its expenditure of Chinese enterprises in the world, and the relative ratio of GDP, the digitization degree of Chinese enterprises is in rapid growth. As companies gradually recover from the global epidemic in 2020, they will also face a large backlog of its projects. However, the funds used to complete these projects are limited. The Gartner report predicts that CIOs may focus their spending on "subscriptions" and "cloud services" to reduce costs. By 2020, infrastructure as a service (LAAS) space is expected to grow by 13.4% to $50.4 billion, and 27.6% to $64.3 billion by 2021.',
      secondDescript2:
        "Therefore, the construction of identity cloud IDaaS will help enterprises realize digital transformation faster, reduce financial burden, and effectively avoid creating obstacles for enterprise development, and increase unnecessary costs.",
    },
    buy: {
      title: "Self-built or purchased third party identity cloud IDaaS ？",
      item1: {
        title: "Reduce development costs",
        descript:
          "Many companies choose to build an internal identity management system from scratch, but this is often difficult to adapt to today's business needs. It takes at least a few months from design to online identity system, which is expensive and labor cost is high. Purchasing a complete third-party identity authentication solution can save the manpower and material resources spent on self-construction, and IDaaS vendors represented by Authing support monthly subscription payments, which can greatly reduce expenses.",
      },
      item2: {
        title: "ROI",
        descript:
          'More and more companies find that adopting third-party identity authentication solutions is faster and easier than building their own. By removing the "identity authentication" from the "plate" of the project, valuable R&D time can be freed, and R&D personnel can focus more on building business logic and enhancing the value of core products instead of building and maintaining corporate identity solutions .',
      },
      item3: {
        title: "Third-party IDaaS accelerates enterprise innovation",
        descript:
          "Every business has its own identity provider and infrastructure. Using third-party identity authentication solutions, companies can complete the integration with any identity provider in an hour or less. By saving thousands of hours of time, companies can focus more on core competitiveness, which speeds up the pace of innovation and enables companies to create more value for customers.",
      },
    },
    service: {
      title:
        "Authing creates an exclusive identity cloud IDaaS service for your enterprise",
      subtitle:
        "As an enterprise level identity management service, authing is not only a software provider, but also a business consulting partner of enterprises. Authing has built exclusive IDaaS services for many of the world's top 500 enterprises.",
      descript: {
        title:
          "Authing builds identity infrastructure for enterprises to accelerate application development and integration through the following three steps:",
        item1:
          "In the early stage, detailed demand collection and investigation are conducted to deeply understand the business status of the enterprise. Combined with the actual scene, the detailed IDA as construction scheme and project schedule is sorted out.",
        item2:
          "After the scheme is confirmed, the Authing core is deployed to the private cloud environment of the enterprise by taking advantage of the original cloud architecture of Authing, and the existing 700+ API is used for flexible and quick two times development until the delivery is completed.",
        item3:
          "Delivery success is just beginning. As an enterprise-level identity management service, Authing is not only a software provider but also a business consulting partner of an enterprise. Authing has an experienced customer success team, which escorts the identity security of enterprises 7 * 24 hours, and provides technical and business consulting services for enterprises.",
      },

      services: {
        title: "The IDaaS built by Authing can bring you the following value",
        item1: {
          title: "Perfect identity service, improve user experience",
          descript:
            "Identity management runs through all the services provided by enterprises for users. An excellent identity management scheme will capture and store user information in an all-round way, from user registration and login, to tracking user preferences in services, and then to precision marketing.",
          imgText: "Authing identity Center",
        },
        item2: {
          title: "Reduce enterprise development cost",
          descript:
            "Subscribing to Authing will save the cost of building an identity management system and reduce the burden of future maintenance and upgrading. The liberated human and material resources can enable the development team to focus on the core business, develop new growth space for the enterprise's innovation ability, and accelerate the time of product delivery and listing.",
          imgText: "Pipeline of Authing",
        },
        item3: {
          title: "Improve operation management efficiency",
          descript: `The internal business of large enterprises and organizations is usually divided according to the dimensions of "region" and "department". Different businesses usually need to ensure independence. Authing identity cloud uses multi tenant technology to help enterprises solve the problem of business and data isolation. At the same time, Authing's enterprise operation center can help administrators manage and operate the tenants conveniently.`,
          imgText: "Authing enterprise operation center - tenant management",
        },
        item4: {
          title: "Enhance identity security and protect data assets",
          descript:
            "Dynamic token, face recognition and other multi-factor authentication (MFA) functions can comprehensively improve the system access security and ensure the user access security.",
          imgText: "Security configuration of Authing",
        },
        item5: {
          title: "Improve the scalability of the system",
          descript:
            "Once the Identity Management API development kit is purchased, the development team can integrate the application to be developed on the platform, without repeated construction and purchase of identity management scheme, which is very friendly to developers. Enterprises can expand the product matrix based on this feature without additional cost for identity management.",
          imgText: "Some SDK of Authing",
        },
        extra:
          "“ IDaaS is a catalyst for enterprises to rapidly realize digital transformation. As a leading identity cloud IDaaS service provider, Authing is constantly creating more value for enterprises.”",
      },
    },
    list: {
      title:
        "List of features required to be included in standard identity cloud",
      subtitle:
        "The following is a list of functions that a standard identity cloud IDaaS needs to include. Of course, each enterprise has its own unique organizational form and business model.",
      table: {
        firstHead: "Primary function",
        secondHead: "Secondary function",
        thirdHead: "Explain",
        item1: {
          title: "Unified account",
          content: {
            subtitle1: "User management",
            descriptions1: {
              description1: "User batch import and export",
              description2:
                "Add / delete / modify / check the user account number item by item / batch",
              description3:
                "User attribute management (basic field + user defined field)",
              description4:
                "User status management (enable / unlock / disable / activate, etc.)",
              description5: "User password reset",
            },
            subtitle2: "Organization and management",
            descriptions2: {
              description1: "Multi level organization structure tree",
              description2: "Organization and management",
            },
            subtitle3: "User group management",
            descriptions3: {
              description1: "User group creation / query / deletion, etc",
              description2: "User group attribute management",
            },
            subtitle4: "Directory synchronization",
            descriptions4: {
              description1:
                "Account synchronization (upstream synchronization)",
            },
          },
        },
        item2: {
          title: "Unified certification",
          content: {
            subtitle1: "Authentication source management",
            descriptions1: {
              description1:
                "It supports authentication source configuration, supports adding enterprise wechat, ad authentication source and LDAP authentication source; supports user-defined authentication source, including authentication source based on openid, SAML and CAS protocol.",
            },
            subtitle2: "Authentication method",
            descriptions2: {
              description1:
                "Support multi-factor authentication, including account name / password, OTP, QR code, social login authentication, etc",
            },
            subtitle3: "Authentication configuration",
            descriptions3: {
              description1:
                "Support different authentication factors for different applications",
            },
          },
        },
        item3: {
          title: "Unified application",
          content: {
            subtitle1: "Application management",
            descriptions1: {
              description1:
                "Support application pre integration; support the creation of custom applications (openid connect, formpost, SAML2.0, CAS, oidc and other standard protocols)",
            },
            subtitle2: "Single sign on",
            descriptions2: {
              description1: "Support the configuration of SSO for applications",
            },
            subtitle3: "Account number supply",
            descriptions3: {
              description1:
                "Support the synchronization of accounts, institutions, etc. to the application system",
            },
            subtitle4: "SaaS service access capability",
            descriptions4: {
              description1:
                "Supports integration of third-party SaaS or enterprise self-built applications through OIDC, SAML, CAS, LDAP, AD and other standard protocols",
            },
            subtitle5: "Tenant-level application access capabilities",
            descriptions5: {
              description1:
                "Support access to different applications according to different tenants of IDaaS identity cloud;",
            },
            subtitle6: "Workbench integration",
            descriptions6: {
              description1:
                "Support enterprise wechat workbench; support adding workbench",
            },
          },
        },
        item4: {
          title: "Unified authority",
          content: {
            subtitle1: "Authority management",
            descriptions1: {
              description1:
                "It supports application level authorization and RBAC based authorization",
            },
            subtitle2: "Permission configuration",
            descriptions2: {
              description1:
                "Support authorization based on user / user group / organization",
            },
            subtitle3: "Permission synchronization",
            descriptions3: {
              description1:
                "Support the synchronization of application permissions",
            },
          },
        },
        item5: {
          title: "Unified audit",
          content: {
            subtitle1: "User action log",
            descriptions1: {
              description1:
                "Support the query and export of user operation log",
            },
            subtitle2: "Administrator operation log",
            descriptions2: {
              description1:
                "Support query and export of administrator operation log",
            },
          },
        },
        item6: {
          title: "Security management",
          content: {
            subtitle1: "Administrator configuration",
            descriptions1: {
              description1:
                "It supports the creation and deletion of administrators / administrator groups, and supports the configuration of different administrator roles",
            },
            subtitle2: "Security policy",
            descriptions2: {
              description1:
                "Support password policy configuration, including password strength settings, password reset settings, login security settings, etc",
            },
          },
        },
        item7: {
          title: "Application access capability",
          content: {
            subtitle1: "SaaS service access capability",
            subtitle2: "Tenant level application access capability",
          },
        },
        item8: {
          title: "Operation and maintenance & operation management capability",
          content: {
            subtitle1: "IDaaS tenant operation platform",
            descriptions1: {
              description1:
                "The enterprise operation center supports centralized management of all tenants, applications, orders, etc. in the identity cloud; core data visualization",
            },
            subtitle2: "IDaaS operation and maintenance platform",
            descriptions2: {
              description1:
                "One-click deployment belongs to the IDaaS platform, and system operation and maintenance, data monitoring, and service upgrades are all under control",
            },
          },
        },
      },
    },
  },
  cognito: {
    title: "Move from AWS Cognito",
    subtitle:
      "Authing can solve many problems in using Cognito. Using the Authing user pool can completely replace Cognito user pool and build a bridge between domestic users and AWS resources.",
    intro: {
      title: "Introduction to AWS Cognito",
      descript1:
        "In the process of web or app development, user authentication and authority processing is a very important module, including user registration, login authentication, and management of corresponding permissions. In addition to user name and password login, it is also a very important demand to log in through a third-party social account. In foreign countries, it is mainly Google, Facebook, or apple login, while in China, it is mainly WeChat and microblog login.",
      descript2:
        "Identity authentication and authorization are complex to implement. Therefore, Cognito service is provided on the AWS cloud to help developers access user registration/login and access control functions faster and more safely. Cognito service allows enterprises to focus more on their core business, focusing on innovation and revenue generation, rather than paying too much attention to the underlying technical details related to authentication and authorization.",
    },
    project: {
      title: "Alternatives",
      item1: {
        title: "Architecture design",
        subtitle: "Demonstrate the overall structure of the website",
        list1:
          "The static website is hosted by S3, and the static content acceleration and the HTTPS certificate mount are carried out by CloudFront.",
        list2:
          "Using Authing to authenticate the login and obtain the token, as an alternative to the user pool.",
        list3: "Access the Rest API provided by API Gateway.",
        list4:
          "Obtain temporary AWS credentials through Cognito Identity Pool to access AWS resources (here, take Polly service as an example).",
        tip:
          "At present, the demo website has been deployed in the domestic area of AWS",
        link: "View visit effect",
      },
      item2: {
        title: "Login authentication and get token by Authing",
        subtitle:
          "Authing authenticates the user based on OIDC and OAuth 2.0 and grants the user access to the corresponding application.",
        list1:
          "The user requests to log in through the Authing user pool and gets the code from the server after successful authentication.",
        list2:
          "The application requests token with code through the identity pool.",
        list3:
          "Users can use token to request access to various application resources.",
        imgText:
          "The above figure describes the OIDC Authorization Code Flow to obtain Token. Users can also obtain token through OIDC Implicit Flow. This example uses Implicit Flow, ",
        link: "View comparison.",
      },
      item3: {
        title: "Access the protected REST API provided by API Gateway",
        subtitle:
          "The token (i.e. id_token) can be obtained after login and authentication through Authing. You can access the protected REST API by carrying a token in the header when sending an HTTP request.",
      },
      item4: {
        title:
          "Secure access to AWS services through integration with Identity Pool",
        subtitle:
          "The token (i.e. id_token) can be obtained after login and authentication through Authing. Through the integration with identity pool, temporary credentials can be obtained to access AWS resources safely.",
      },
    },
    replace: {
      title: "Replace AWS Cognito with Authing",
      item1: {
        title: "Pain point",
        subtitle:
          "Although AWS is the world's largest cloud computing provider, Cognito services are not available on the Chinese mainland. For enterprises that want to use the IDaaS services such as Cognito, Authing is the best alternative to Cognito.",
      },
      item2: {
        title: "The value of Authing",
        subtitle:
          "Authing can solve many problems in using Cognito. Using the Authing user pool can completely replace Cognito user pool and build a bridge between domestic users and AWS resources.",
      },
    },
    deploy: {
      title: "Scheme deployment",
      subtitle1:
        "Both the front-end and back-end code of the demo site have been published in the Github:",
      subtitle2:
        "you can refer to the relevant code for deployment and testing.",
      item1: {
        title: "Authing account opening and OIDC application configuration",
        subtitle1:
          "First of all, you need to create an OIDC application in Authing. For details, please refer to the ",
        subtitle2:
          ".The demo environment uses implicit flow and rs256 algorithm for id_token signature. Refer to the left figure for callback URL, authorization mode and return type settings.",
        imgText: "Callback URL, authorization mode, return type, etc",
        link: "View document",
      },
      item2: {
        title: "Deploying API gateway and lambda through Sam",
        subtitle1:
          "Since the id_token is encrypted by rs256 algorithm, the corresponding key needs to be set in lambda authorizer for token verification. For details, please refer to the example code app.js Related notes in ",
        subtitle2:
          "In the demonstration environment, API Gateway and related lambda have been described in an AWS Sam template, which can be deployed automatically through Sam.",
        link: "View document",
      },
      item3: {
        title: "Configuration of integrating Authing and Identity Pool",
        subtitle:
          "At the same time, Cognito Identity Pool will create two Iam roles (for authenticated users and anonymous users). You need to set the permissions for the IAM Role of the authenticated user. The sample website uses Polly service, so you need to add the permission to access Polly.",
        config: "Config",
        configTip: "Config OIDC Provider",
        provider: "Provider URL",
        providerTip:
          "It is the corresponding issuer of the Authing application",
        audience: "Audience",
        audienceTip:
          "This is the app ID corresponding to the Authing application",
        doc: "Reference documents",
        docTip:
          "Please refer to relevant official documents of AWS for specific configuration ",
        configIdentity: "Config",
        configIdentityTip: "Config Cognito Identity Pool",
        authenticated: "Authenticated Provider",
        authenticatedTip: "Specify Authing as Authenticated Provider",
        imgText: "Create success examples",
        demoLink: "View demo",
        docLink: "View document",
      },
      item4: {
        title: "Deploy static website as front end demo",
        subtitleTitle: "Front end demo page:",
        subtitle:
          "It can be uploaded to the S3 bucket and enable the S3 static website hosting function. Note that CloudFront and HTTPS certificate should be added in the front, or you can choose to deploy on an EC2.",
      },
    },
  },
  keycloak: {
    banner: {
      title: "Building an identity system",
      subtitle: "How to choose open-source framework and enterprise software?",
    },
    problem: {
      title: "Advantages & problems of open source software",
      description:
        "Keycloak is an open-source software product designed to provide a single sign-on a tool with identity management and access management functions for modern applications and services. Authing is an enterprise-level identity authentication product, which integrates all the mainstream identity authentication protocols and provides complete and secure user authentication and access management services for enterprises and developers.",
      advantage: {
        title: "Advantage",
        item1: "Free for commercial use",
        item2:
          "Reduce the cost of development, quickly launch their own products",
        item3: "Very flexible,and can customize and modify the source code",
        item4:
          "Everyone can access the code, and anyone can actively modify the bug to make it better",
      },
      question: {
        title: "Problem",
        descript1:
          "First of all, open-source software is not completely free. Developers develop products and open source code according to their own wishes, but this is not the demand of consumers, which leads to the reduction of user experience and requires additional time or cost to get technical help. Secondly, the security of open-source software is low. When an open source component has a vulnerability, the vulnerability will be quickly disclosed so that developers can perform the necessary repair. However, hackers can not help but see what information is vulnerable to any attack, and they need to pay attention to potential threats.",
        descript2: `Since open-source software can be freely available on the Internet, it brings a large number of users' suggestions on bug fixing. This may lead to a large number of patches, making the source code more complex, and even structural problems, which often lead to high maintenance costs and high maintenance costs. Without the stimulation of commercial profits, open-source software is bound to lack a healthy upstream and downstream "ecosystem". To achieve direct commercial profits through open source software, we must carry out the necessary deep development.`,
      },
    },
    enterprise: {
      title: "Enterprise software",
      subtitle:
        "No pants are suitable for everyone, no software is suitable for all enterprises, and software solutions and services for enterprises are always more important than software products. Therefore, enterprise-class software tailored for enterprises stands out in the market and receives more attention.",
      descript1: `Compared with open source software, enterprise software is usually tailored for large enterprises with a large number of features. Suppliers are well aware of the needs of industry standards and standard companies and include these concepts in their programming, which can not only bring professional technical support, but also help companies maintain competitiveness. Besides, standard enterprise software does not require a lot of programming work, and is usually "out of the box". Therefore, the special temptation of open source is negligible for enterprise business, which will greatly improve enterprise efficiency. In addition, enterprise-level software is often updated, which not only upgrades functions but also fixes vulnerabilities, which is more secure than open-source software.`,
      descript2:
        "The emergence of open-source software has brought good news to the vast number of developers so that developers can save the trouble of rewriting code. The birth of enterprise products directly liberates hands, that is, take and use, with comprehensive services to provide security for enterprises.",
    },
    table: {
      title: "Keycloak or Authing？",
      subtitle:
        "Authing and Keycloak support many standard functions in authentication and access management solutions, such as secure registration and authentication, OAuth token and API key management, single sign-on (SSO), and multi-factor authentication (MFA). They are also free and available from the active user community.",
      tableList: {
        item1: "Authentication of web and mobile",
        item2: "Connect to custom database",
        item3: "Fine grained access control",
        item4: "Login form component",
        item5: "Multiple applications and single sign on",
        item6: "Dynamic adaptive multi-factor authentication",
        item7: "User management interface",
        item8: "Self hosting and private cloud options",
        item9: "Audit log",
        item10: "Support multiple SDK",
        item11: "Business support",
        item12: "Security Patch",
        item13: "Custom user data",
        item14: "Password leak detection (real time)",
        item15: "Language internationalization",
        item16: "Connect Custom Social login",
        item17: "Password strength",
        item18: "Webhooks and events",
        item19: "Strong data isolation",
        item20: "Support multi tenant applications",
        item21: "Brute force detection",
        item22: "Custom password encryption algorithm",
        item23:
          "Implementation of custom password encryption algorithm through plug-in",
        item24: "Advanced user search and segmentation",
        item25: "Email template",
        item26: "No password change required for user migration",
        item27: "Advanced licensing and compliance management",
        item28: "Customized function development",
        item29: "Second level installation and deployment",
        item30: "Fast request response time",
        item31: "Perfect development documents",
      },
    },
    compare: {
      title: "Function comparison between Authing and Keycloak",
      item1: {
        title: "User experience UI / UE",
        descript:
          "From the perspective of user experience, the Keycloak console is a traditional industrial style, which is old in an interactive experience and unfriendly in user operation. In contrast, the business logic of Authing console is more friendly and the business arrangement is clearer.",
      },
      item2: {
        title: "Standard authentication protocols supported by default",
        descript:
          "Keycloak currently only supports OIDC and SAML2.0 protocols, while Authing supports OAuth 2.0, OIDC, SAML, AD / LDAP, WS fed and other mainstream authentication protocols.",
      },
      item3: {
        title: "Webhooks and events",
        descript:
          "Keylcoak doesn't support webhooks, but it can be customized through a complex extension of SPI, which is very complex to implement. Authing supports webhooks. The user pool administrator can configure the notification address of all kinds of events in the console. When your platform has users registering, logging in, modifying personal data and password, your server will be automatically informed.",
      },
      item4: {
        title: "Business support",
        descript:
          "Keycloak is based on the business application friendly Apache license protocol, but Keycloak still has some work to do to make it commercial, and its efficiency is very low. In terms of business support, Authing not only has 3000 free API calls to experience all functions but also has different types of customized services such as developer version advanced version and enterprise version, to fully meet the business needs of customers.",
      },
      item5: {
        title: "Security Patch",
        descript:
          "Keycloak, as an open-source software, is relatively slow to update. As professional enterprise software, Authing will release function updates and patches regularly. Authing also offers many support and hosting options for companies with platform dependencies.",
      },
      item6: {
        title: "No password change required for user migration",
        descript:
          "Keycloak can't realize user migration without changing the password. Authing supports the implementation of user-defined password encryption and decryption functions through function calculation and can customize password verification logic so that users can seamlessly migrate to Authing.",
      },
      item7: {
        title: "Advanced licensing and compliance management",
        descript:
          "Keycloak doesn't have a perfect advanced license and compliance management, but Authing has international authoritative security certification and a mature information security management system, which can guarantee the whole life cycle of software, and has reliable data security protection and all-weather security emergency response measures.",
      },
      item8: {
        title: "Second level installation and deployment",
        descript:
          "Keycloak provides traditional deployment methods, such as supporting multiple container deployment clusters, supporting centralized configuration management, supporting private deployment in the complex network environments, and so on. Authing also supports these. Also, Authing provides private deployment services for enterprise users and provides one-click deployment installation package, which can deploy Authing to your internal server in seconds.",
      },
      item9: {
        title: "Customized function development",
        descript:
          "Keycloak does not provide custom function development. Authing can customize an exclusive identity authentication platform for enterprises according to the needs of customers.",
      },
    },
    remark: {
      descript:
        "Keycloak,as an open-source software, can be used out of the box in simple scenarios, but if you want to configure more complex scenarios, its operation difficulty and workload will also increase. Authing, as an enterprise level professional product, is smooth and simple, and takes less time to integrate. If enterprises want to quickly improve production efficiency, enhance security, and promote business development, Authing must be a more correct choice.",
    },
  },
  mfa: {
    banner: {
      title: "Adaptive MFA",
      subtitle:
        "After enabling multi-factor authentication, users need to provide not only the user name and password (the first authentication), but also the verification code (the second authentication). The combination of multi-factor authentication will provide higher security protection for your account and resources.",
    },
    challenge: {
      title: "Challenges facing modern enterprises and organizations",
      subtitle: `The rapid development of big data, the Internet, and 5G, while bringing unlimited development opportunities to mankind, has also spawned a large number of information leakage incidents. According to the "IBM 2020 Data Breach Report", the average total cost of a data breach is 3.86 million U.S. dollars (approximately RMB 25.21 million)`,
      description1:
        "For companies, the cost of data breaches is getting worse. On the one hand, companies will be punished by regulators. For example, British Airways was fined 204 million euros by the Office of the Information Commissioner (ICO) for data breaches. On the other hand, once a data leak occurs, it will not only make the company lose the trust of customers and users, but also affect the company's long-term development.",
      description2:
        "Therefore, the use of multi-factor authentication (hereinafter collectively referred to as MFA) has become a basic means for enterprises to prevent data leakage. Multi-factor authentication requires users to use at least two factors to verify their identity, and only after passing the verification can they access applications, which is rapidly spreading among enterprises.",
      description3:
        "At the end of last year, LastPass conducted a survey of 47,000 companies and found that 57% of companies worldwide are currently using multi-factor authentication, an increase of 12% over the previous year. Statistics also prove the effectiveness of MFA. Earlier this year, Microsoft reported that 99.9% of the illegal accounts it tracks did not use multi-factor authentication.",
    },
    features: {
      title: "Authing multi-factor authentication core function",
      item1:
        "Authing guarantees business security through multiple authentication methods",
      item2:
        "Customized authentication process, one-key open, simple operation",
      item3:
        "Support equipment environmental data reporting, multi-dimensional analysis of security levels",
      item4:
        "Support configuration strategy to achieve environmental risk adaptation",
      item5: "Also suitable for in-app permission control scenarios",
      item6: "Integrated into the universal login component (Guard) by default",
      item7: "User data management, behavior log query",
      item8:
        "Provide SDK and open interfaces to help developers quickly call-related capabilities and build custom user management pages",
    },
    mode: {
      title:
        "Multiple authentication methods to improve corporate identity security",
      item1: {
        title: "Mobile token",
        list1:
          "With strong dynamic OTP password verification, it helps protect account security and avoid malicious attacks.",
      },
      item2: {
        title: "SMS/email verification code",
        list1: "Easy to use",
        list2: "Convenient",
        list3: "Improve login security",
      },
      item3: {
        title: "Compatible with third-party authenticators",
        list1: "Compatible with third-party authenticators",
        list2:
          "To avoid the pain of not being able to receive verification text messages, it can be used without an internet connection, and the phone outage will not be affected.",
      },
      item4: {
        title: "Biometrics",
        list1:
          "Fingerprint/face, as a key factor of human body characteristics, is widely used in the field of security authentication.",
        list2:
          "High security, high precision, authentication can be completed without entering a password.",
      },
      item5: {
        title: "Graphic lock",
        list1: "Simple and easy to use",
        list2: "Security can be enhanced with more complex graphics",
      },
      item6: {
        title: "Mini Program Certification",
        list1:
          "Integrate the Authing mobile token validator into the WeChat applet, eliminating the need to install the app, and quickly use the mobile validator.",
      },
    },
    advantage: {
      title: "Advantages of Authing multi-factor authentication",
      subtitle:
        "Empower Authing applications to quickly enable multi-factor authentication (MFA), and immediately improve application authentication and access security levels",
      item1: {
        title: "Developer friendly",
        subtitle:
          "Provides an out-of-the-box client SDK to facilitate client developers to quickly implement MFA",
        list1: "· Support multiple terminals: Web, iOS, Android",
        list2:
          "· Built-in multiple multi-factor authentication terminal components, such as OTP, verification code, fingerprint unlock, facial recognition, graphic lock, etc.",
        list3:
          "· Only need to call a method to evoke the MFA certification component, get the certification result, and complete the certification process",
      },

      item2: {
        title: "Custom data reporting",
        subtitle:
          "Customized data reporting, participating in the process to initiate decision-making, covering more complex and refined scenarios",
        list1: "· Support data reporting during Authing SDK initialization",
        list2: "· Support timing data reporting",
        list3: "· Support active data reporting during application runtime",
      },
      item3: {
        title: "Strategy-based",
        subtitle:
          "The trigger conditions for multi-factor authentication are based on custom strategies, and the strategy system is simple, efficient, complete and flexible",
        list1:
          "· Simple: you don’t want to configure a complicated strategy, you can use the default security strategy or preset hit conditions",
        list2:
          "· Efficient: Millisecond level judgment strategy hits, multi-factor authentication is immediately aroused; based on the good user interface",
        list3:
          "· Complete: The strategy is described based on functional expressions, and developers can obtain enough information (including but not limited to user information, equipment, network, location, behavior, custom report data, etc.) to write strategy hit logic ",
        list4:
          "· Flexible: Hit judgment based on multiple methods at the same time",
      },
      item4: {
        title: "Simple configuration",
        subtitle:
          "Based on a friendly user interface, quickly configure multi-factor authentication for specific applications",
        list1: "· One-click on/off multi-factor authentication",
        list2:
          "· One-click to enable the default security policy, no need to understand the policy configuration, can also greatly improve application security",
        list3:
          "· Preset dozens of important and commonly used strategy hit conditions, which will take effect upon selection and can be used by non-engineers",
      },
    },
    performance: {
      title: "Adaptive multi-factor authentication, higher performance choice",
      subtitle: `Compared with traditional multi-factor authentication, "adaptive" multi-factor authentication can choose to apply different MFA methods according to the current security situation, so as to ensure security while also taking into account the user experience. "Adaptive" multi-factor authentication provides a more flexible and intelligent verification strategy.`,
      secondTitle: `When the user goes through the authentication process, "adaptive" multi-factor authentication generates multiple "key elements" for the currently logged-in user`,
      item1: {
        title: "User attributes",
        subtitle:
          "Such as user name, password, user identity and other attributes and information of the user",
      },
      item2: {
        title: "Location awareness",
        subtitle:
          "Location awareness is divided into the virtual location (IP address) and physical location (country, region, etc.)",
      },
      item3: {
        title: "Request source",
        subtitle:
          "Judge the source of the current user’s request, such as hardware device information, the user’s current system, etc.",
      },
      item4: {
        title: "Biometrics",
        subtitle:
          "Use the user's biological information for identification, such as fingerprint information, face recognition, etc.",
      },
      item5: {
        title: "Behavior analysis",
        subtitle:
          "A series of user behaviors such as whether it comes from a commonly used login location, whether the wrong password is entered multiple times, and the user's previous operation records",
      },
    },
    example: {
      title: "MFA industry use cases",
      subtitle:
        "In general, we see a tendency to use MFA in industries dealing with sensitive data, such as insurance and banking. There is no additional identity layer in these vertical domains, so there is an urgent need for MFA.",
      description1:
        "MFA is one of the best ways to prevent accounts from being stolen. If an attacker wants to invade an account protected by MFA, he not only needs to steal credentials, but also needs to verify additional factors. MFA greatly increases the time and energy required by attackers to invade accounts, so it is difficult for them to carry out large-scale attacks.",
      description2:
        "Authing can centrally configure a variety of authentication factors other than passwords, including dynamic token, certificate, face, fingerprint and other biometrics. It can integrate a variety of common third-party authentication sources. At the same time, the developer API is provided to support other applications to use the identity authentication ability of IDaaS.",
      systems: {
        finace: "Financial system",
        item1: {
          title: "Ensure access to financial data",
          subtitle:
            "In order to protect financial data and online transactions from criminals, multi-factor authentication (MFA) of Authing is used to verify the identity of users.",
          list1:
            "When logging into financial websites and apps, the MFA of Authing sends authentication information to users' smartphones to prevent unauthorized access.",
          list2:
            "When conducting financial transactions, the MFA of Authing double verifies the user's identity to ensure the identity security of trading partners and protect online transactions from criminals.",
        },
        education: "Educational system",
        item2: {
          title: "Protecting higher education",
          subtitle:
            "Using the trusted MFA solution of Authing it provides secure application access for students and staff.",
          list1:
            "Authing verifies the user's identity through multi-factor authentication (MFA), and checks the security status of the device before granting access to the web page and application, so as to ensure that only trusted users and devices can access the organization's website and application.",
          list2:
            "After the MFA is deployed to its teachers and students, it can improve the accuracy of identity authentication and ensure that students and staff will not be victims of phishing attacks.",
        },
        govenment: "Government affairs system",
        item3: {
          title: "Security for government agencies",
          subtitle: `Using the MFA solution of Authing, we can start the journey of "zero trusts", help government agencies reduce risks, and promote the realization of government modernization.`,
          list1:
            "Local governments rely on various tools to manage sensitive personal information and provide basic community services. Deploying the MFA of Authing can maintain the security of government applications and improve the security of government applications.",
          list2:
            "Authing protects against phishing and blackmail attacks by preventing devices from accessing applications without authorization. Government agencies can safely and easily access websites and applications to serve the community without managing complex IT environments.",
        },
      },
    },
  },
  buildAd: {
    banner: {
      title: "Completely replace AD",
      subtitle:
        "When there is a better choice than AD (Active Directory), why choose the one that can not fully meet the needs of the enterprise? Choosing Authing identity authentication platform can meet the modern needs of your enterprise.",
    },
    intro: {
      item1: {
        title: "AD makes everything more difficult",
        descript:
          "The company is growing, but AD has not kept pace. AD now makes it harder for you to support contractors, freelancers, and teleworkers. It creates extra work and hinders the company's innovation and modernization.",
      },

      item2: {
        title: "Transition to Authing",
        descript:
          "Unlike Microsoft AD, the Authing identity cloud is built to meet the company's long-term needs. Authing identity cloud is a modern directory, which not only provides single sign-on (SSO), life cycle management and multi factor authentication.",
      },

      item3: {
        title: "Security, productivity, flexibility",
        descript:
          "The function of Authing can accommodate multiple identities and devices. With more than 6000 integrations in the Authing integration network, Authing can connect anyone associated with your organization to any technology they want to use. By focusing on users, Authing implements a zero-trust approach to security, so you don't have to worry.",
      },

      item4: {
        title: "The conversion is worth it",
        descript:
          "Choosing Authing means taking back control of the authentication process and data. Starting today, Authing can help you complete the transformation.",
      },
    },
    features: {
      title: "Rethinking the AD maturity model",
      axisX: "Business Modernity",
      axisY: "Business Agility",
      item1: {
        title: "Present situation",
        list1: "All users stored in AD",
        list2: "AD controls all machines and accesses them through GPO",
        list3: "SaaS uses independent login",
      },
      item2: {
        title: "Extending AD with the single sign-on",
        list1:
          "IDaaS is integrated with AD and supports single sign-on for SaaS and local applications",
        list2: "IDaaS centralized security policy",
        list3: "MFA protects applications and resources",
      },
      item3: {
        title: "Establishing IDaaS identity Center",
        list1:
          "IDaaS purchases employees directly from human resources and assigns them to AD",
        list2: "Local nonemployees managed by IDaaS",
        list3: "Device management solutions control end-user devices",
      },
      item4: {
        title: "Secure identity cloud",

        list1:
          "IDaaS controls access to all applications and resources through adaptive policies and password-free authentication",
        list2:
          "Device management and IDaaS solutions share device and user context",
        list3:
          "IDaaS protects access to servers and network resources (such as VPN and WiFi)",
        list4:
          "SaaS file synchronization and sharing solution replaces file server",
        list5: "Cloud Print Service replaces print server",
      },
    },
  },
  privateCloud: {
    banner: {
      title: "Private deployment of identity cloud",
      subtitle:
        "Authing is one trusted platform to secure every identity. Many of the world’s top 500 enterprises trust Authing’s software and APIs to sign in, authorize and manage users.",
    },
    resource: {
      title: "Resource Center",
      mirror: {
        title: "Privatization deployment plan",
        content:
          "If you need to privatize the deployment of Authing, click to learn about the deployment plan",
        "button-link": "View now",
      },
      docs: {
        title: "Quick start",
        content:
          "Easily integrate the identity system for your application and guide the deployment problems",
        "button-link": "View now",
      },
      "price-title": "Flexible pricing for companies and developers",
    },
    advantage: {
      title: "Our Advantages",
      item1: {
        title: "Improve the efficiency of operation management",
        content: `The internal of large enterprises and organizations usually divide business according to the dimensions of "region" and "department". Different businesses usually need to ensure independence. Authing uses multi tenant technology to help enterprises solve the problem of business and data isolation. Meanwhile, Authing's enterprise operation center can help you manage and operate tenants conveniently.`,
      },
      item2: {
        title: "Improve user experience with excellent identity service",
        content:
          "Identity management runs through all the services provided by enterprises for users. An excellent identity manage-ment scheme will capture and store user information in an all-round way from user registration and login, to tracking user preferences in services, and then to precision marketing.",
      },
      item3: {
        title: "Improve identity security and protect data assets",
        content:
          "Functions such as dynamic token, face recognition and other multi factor authentication (MFA) can comprehensively improve the system access security and ensure the user access security.",
      },
      "customer-common":
        "“Compared with many manufacturers, we can feel the advantages of Authing. This is a product made through thinking”",
      "customer-link": "Read customer success stories",
      integrate: {
        title:
          "3 steps accelerates application development and integration for enterprise identity infrastructure:",
        item1:
          "In the early stage, we carried out detailed demand collection and research to deeply understand the business status of the enterprise. Combined with the actual scene, we sorted out the detailed construction scheme and project schedule of IDaaS.",
        item2:
          "After the scheme is confirmed, the authing kernel is deployed to the enterprise private cloud environment by using the advantages of Authing's cloud native architecture, and the existing 700 + API is used for flexible and fast secondary development until the delivery is completed.",
        item3:
          "Authing is not only a software provider, but also a business consulting partner of the enterprise. Authing has an experienced customer success team, which escorts the identity security of the enterprise in 7 * 24 hours, and provides technical and business consulting services for the enterprise.",
      },
    },
    question: {
      title: "Common problem",
      item1: {
        title: "How to choose the authentication method?",
        list1:
          "If you don't understand OAuth, OIDC, SAML, LDAP and other standard protocols, and the application security requirements are not high, it is recommended to use ordinary authentication.",
        list2:
          "If your application requires high security, whether you know the standard protocol or not, please use the standard protocol authentication.",
      },
      item2: {
        title: "What is Authing?",
        list1:
          "Authing provides professional authentication and authorization services for enterprises and developers in the cloud.",
        list2:
          "You can connect any platform application to Authing (whether it's a newly developed application or an old application). At the same time, you can customize the login mode of the application (such as email / password, SMS / verification code, social login, etc.).",
        list3:
          "You can choose our SDK or call related API to access your application according to the technology you use. When a user initiates an authorization request, Authing will help you authenticate their identity and return the necessary user information to your application.",
      },
      item3: {
        title: "Why use Authing?",
        list1:
          "You want to develop a cool program, then you want to add user authentication and authorization. You want your users to log in using wechat and GitHub. At the same time, you also want to track the registration source and activity data of users, so that you can do subsequent user growth.",
        list2:
          "You have made an API, and you want to use OAuth 2.0 to ensure the API security.",
        list3:
          "You have made a lot of applications, and you hope that the user data of these applications can be exchanged through single sign on.",
        list4:
          "You have made a JavaScript front-end application and a mobile application. You want these two client applications to be able to access your API safely.",
        list5: "You need to build a web application that supports SAML login.",
        list6:
          "You think the password is very fragile, so you want users to log in with one-time mobile phone verification code or email verification code.",
        list7:
          "If your user's password is leaked on other websites, you want to be informed so that you can inform your user to reset the password.",
        list8:
          "If a user fails to log in continuously, you want to prohibit their IP to prevent DDoS attack or brute force password cracking.",
        list9:
          "You are in a large enterprise that wants to combine its existing enterprise directory to allow employees to log in to various internal and third-party applications using their existing enterprise credentials.",
        list10:
          "You don't want (or don't know how) to implement your own user management solution. You don't want to develop repetitive UI such as password reset, create, configure, block and delete users. You just want to focus on your own business development and product design. At this time, you can choose Authing as the authentication middleware.",
        list11:
          "You want to enforce multiple authentication when users want to access sensitive data.",
        list12:
          "You are looking for an identity solution that can help you meet the growing compliance requirements of soc2, gdpr, openid connect, etc.",
        list13:
          "You want to use data analysis to track users on your website or application. You also want to use this data to expand customer acquisition channels, measure user retention, and gradually improve the registration process.",
      },
    },
  },
};
